import React, { useCallback } from 'react'
import { styled } from '@mui/material/styles'
import { Modal as MuiModal, Box } from '@mui/material'

export interface ModalProps {
  open: boolean;
  width?: number | string;
  onClose: () => void;
  children: React.ReactNode;
  maskClosable?: boolean;
  escapeClosable?: boolean;
}

export const ModalContent = styled(Box)(() => ({
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  transition: 'all 0.2s linear',
}))

const Modal: React.FC<ModalProps> = (props) => {
  const { open, onClose, width, maskClosable, escapeClosable, children } =
    props

  const handleModalClose = useCallback(() => {
    if (maskClosable) {
      onClose()
    }
    if (escapeClosable) {
      onClose()
    }
  }, [escapeClosable, maskClosable, onClose])

  return (
    <MuiModal
      aria-labelledby="modal-component"
      disableAutoFocus={true}
      // disableEnforceFocus={true}
      disableRestoreFocus={true}
      keepMounted={false}
      open={open}
      onClose={handleModalClose}
    >
      <ModalContent sx={{ width, minHeight: '200px' }}>{children}</ModalContent>
    </MuiModal>
  )
}

export * from './comfirmation'
export default Modal
